<template>
  <div class="vehicle-document-status-icons">
    <BaseTooltip
      v-for="document in normalizedSummary"
      :key="document.document_kind"
      position="top"
      :max-width="260"
    >
      <span
        class="vehicle-document-status-icons__item"
        :class="`vehicle-document-status-icons__item--${document.status}`"
      >
        <AppIcon :name="iconName(document)" :size="14" />
      </span>

      <template #content>
        <span class="vehicle-document-status-icons__tooltip">
          <strong>{{ document.label }}</strong>
          <span>{{ statusLabel(document) }}</span>
          <span v-if="document.document_name">
            {{ document.document_name }}
          </span>
          <span v-if="documentMeta(document)">
            {{ documentMeta(document) }}
          </span>
          <span v-if="document.document_id">
            {{ attachmentsLabel(document) }}
          </span>
          <span v-if="document.documents_count > 1">
            Всего документов: {{ document.documents_count }}
          </span>
        </span>
      </template>
    </BaseTooltip>
  </div>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";
import {
  vehicleDocumentAttachmentsLabel,
  vehicleDocumentIconName,
  vehicleDocumentMeta,
  vehicleDocumentStatusLabel,
} from "@/utils/vehicleDocumentPresentation";

export default {
  name: "VehicleDocumentStatusIcons",

  components: {
    AppIcon,
  },

  props: {
    documentsSummary: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    normalizedSummary() {
      return this.documentsSummary.filter(
        (document) => document && document.document_kind
      );
    },
  },

  methods: {
    iconName(document) {
      return vehicleDocumentIconName(document.document_kind);
    },

    statusLabel(document) {
      return vehicleDocumentStatusLabel(document.status);
    },

    documentMeta(document) {
      return vehicleDocumentMeta(document);
    },

    attachmentsLabel(document) {
      return vehicleDocumentAttachmentsLabel(document);
    },
  },
};
</script>

<style scoped>
.vehicle-document-status-icons {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
}

.vehicle-document-status-icons__item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: 1px solid #dbe4f0;
  border-radius: 6px;
  background: #fff;
  color: #64748b;
}

.vehicle-document-status-icons__item--filled {
  border-color: #bbf7d0;
  background: #f0fdf4;
  color: #166534;
}

.vehicle-document-status-icons__item--warning {
  border-color: #fde68a;
  background: #fffbeb;
  color: #92400e;
}

.vehicle-document-status-icons__item--expired {
  border-color: #fecaca;
  background: #fef2f2;
  color: #991b1b;
}

.vehicle-document-status-icons__item--missing {
  border-style: dashed;
  background: #f8fafc;
  color: #cbd5e1;
}

.vehicle-document-status-icons__tooltip {
  display: grid;
  gap: 3px;
}

.vehicle-document-status-icons__tooltip strong {
  font-size: 13px;
}
</style>
